__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.9.3-0932670-16768/_next/";